/** @format */

import axios from "axios";
import { clearAccessToken, getAccessToken } from "./AuthStatus";

// Create an axios instance with a base URL
const ApiClient = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_URL,
});

// Request interceptor to add Authorization header dynamically
ApiClient.interceptors.request.use(
    (config) => {
        const token = getAccessToken(); // Fetch the latest token for every request
        console.log("Token in request interceptor:", token);

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        } else {
            console.warn("No token found in cookies. Authorization header not set.");
        }

        return config;
    },
    (error) => Promise.reject(error)
);

ApiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Handle 401 and 403 (Unauthorized) errors
        if (
            (error.response?.status === 401 || error.response?.status === 403) && !originalRequest._retry) {
            clearAccessToken()
            window.location.href = "/";
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default ApiClient;
